'use client';

type TObject = { [key: string]: any } | any[];

export class LocalStorage {
  private localStorage: Storage | undefined;

  constructor() {
    if (typeof window !== 'undefined') {
      this.localStorage = window.localStorage;
    }
  }

  setString(key: string, value: string) {
    console.info(`Saved to local storage key: ${key} with value: ${value}`);
    this.localStorage?.setItem(key, value);
  }

  setObject(key: string, value: TObject) {
    const jsonValue = JSON.stringify(value);
    console.info(`Saved to local storage key: ${key} with value: ${jsonValue}`);
    this.localStorage?.setItem(key, jsonValue);
  }

  getString(key: string, defaultValue: string): string {
    return (
      (this.localStorage && this.localStorage.getItem(key)) || defaultValue
    );
  }

  getObject<T extends TObject>(key: string, defaultValue: T): T {
    try {
      const rawJson = this.localStorage?.getItem(key);
      if (!rawJson) {
        return defaultValue;
      }
      return JSON.parse(rawJson) as T;
    } catch (err) {
      console.error('Error parsing JSON from LocalStorage', err);
      return defaultValue;
    }
  }

  removeItem(key: string) {
    this.localStorage?.removeItem(key);
  }
}
